import styled from 'styled-components';

export const ErrorMessage = styled.span`
  display: block;
  color: ${({ theme }) => theme.pallete.errorTextColor};
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1.2rem;
`;
